import React, { useEffect, useMemo, useRef, useState } from 'react';
import DownloadInstagramContent from './DownloadInstagramContent';
import ChooseContent from './ChooseContent';
import GeneralExampDownloadContent from './GeneralExampDownloadContent';
import WhyDownloadStoriesContent from './WhyDownloadStoriesContent';
import InstagramActivityTrackerContent from './InstagramActivityTracker';
import CustomersTalkUsContent from './CustomersTalkUsContent';
import FAQContent from './FAQContent';
import BestTipsContent from './BestTipsContent';
import DownloadStoriesBottomContent from './DownloadStoriesBottomContent';
import CommentsPlan from './CommentsPlan';
import TopSearchContent from './TopSearch';
import PostInfoPannel from './PostInfoPannel';
import InstagramAccountInfo from '../Common/InstagramAccountInfo';
import PostListContent from './PostListContent';
import Disclaimer from '@/components/LandingPage/Disclaimer';

import { isEmpty } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import {
  InstagramPostsCommentsItemModel,
  InstagramQueryPostItemModel,
  InstagramQueryPostsModel,
  InstagramUserSubModel,
  PostAnalysisModel,
  PostCommentAnalysisModel,
} from '@/types/anonymously.interface';
import useCheckIsMobile from '@/lib/hooks/useCheckIsMobile';
import useRegisterOrLoginGuide from '@/lib/hooks/common/useRegisterOrLoginGuide';
import {
  fetchInsPostCommentPostData,
  fetchInsPostCommentAnalysisData,
  fetchInsPostCommentPostAnalysisData,
  fetchInsPostCommentUserSubData,
} from '@/lib/service/anonymously';
const UserSub = dynamic(() => import('./UserSub'), {
  ssr: false,
});
const SentimentBreakdown = dynamic(() => import('./SentimentBreakdown'), {
  ssr: false,
});
const AccountPerformance = dynamic(() => import('./AccountPerformance'), {
  ssr: false,
});
const CommonSimpleModal = dynamic(() => import('../Common/CommonSimpleModal'), {
  ssr: false,
});
import { message } from 'antd';
import AlterModal from './AlterModal';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
import { InsAccountModel } from '@/types/home';
import useCommentViewPremium from '@/lib/hooks/isPremium/useCommentViewPremium';

const defaultAnalysisPostData = {
  user: {
    pk: '20824486',
    pk_id: '20824486',
    username: 'nba',
    full_name: 'NBA',
    is_private: false,
    is_active_on_text_post_app: false,
    strong_id__: '',
    profile_grid_display_type: '',
    id: '20824486',
    is_verified: true,
    profile_pic_id: '3531416984933922096_20824486',
    profile_pic_url:
      'https://instagram.fphl1-1.fna.fbcdn.net/v/t51.2885-19/471439176_593449846737443_1034489546725546623_n.jpg?stp=dst-jpg_s150x150_tt6&_nc_ht=instagram.fphl1-1.fna.fbcdn.net&_nc_cat=1&_nc_oc=Q6cZ2QHtt3MoT48r91nKe4q2uQVvZKaFtYn4Pjia_R3yhJpgR7dTJsYkecMlIBYC-Fkybd4&_nc_ohc=wfdKkvUS5SoQ7kNvwHYUCiX&_nc_gid=2IgC3w2YUk0scYegkv4fvA&edm=AEF8tYYBAAAA&ccb=7-5&oh=00_AfS1hUcbKwn-cwOMe41VGjv84hIBTfVANQmleHPuLUkEnw&oe=687C1516&_nc_sid=1e20d2',
  },
  start_date: '2025-07-08',
  end_date: '2025-07-13',
  total_posts: 2,
  average_comments: 484.5,
  average_likes: 61829.5,
  average_engagement_rate: 0.07,
  average_posts_per_day: 0.33,
  api_call_count: 1,
  daily_analysis: [
    {
      date: '2025-07-08',
      posts: 1,
      comments: 909,
      likes: 112442,
      engagement_rate: 0.12,
    },
    {
      date: '2025-07-09',
      posts: 0,
      comments: 0,
      likes: 0,
      engagement_rate: 0,
    },
    {
      date: '2025-07-10',
      posts: 0,
      comments: 0,
      likes: 0,
      engagement_rate: 0,
    },
    {
      date: '2025-07-11',
      posts: 0,
      comments: 0,
      likes: 0,
      engagement_rate: 0,
    },
    {
      date: '2025-07-12',
      posts: 0,
      comments: 0,
      likes: 0,
      engagement_rate: 0,
    },
    {
      date: '2025-07-13',
      posts: 1,
      comments: 60,
      likes: 11217,
      engagement_rate: 0.01,
    },
  ],
};

export default function PostComments({ data }: { data: any }) {
  const contentData = data.contentData;
  const { t } = useTranslation('common');
  const [searchStr, setSearchStr] = useState('');
  const [loading, setLoading] = useState(false);
  const [queryPostsModel, setQueryPostsModel] = useState<InstagramQueryPostsModel>();
  const [currentSelectedPostCode, setCurrentSelectedPostCode] = useState<string>();
  const [currentSelectedPost, setCurrentSelectedPost] = useState<InstagramQueryPostItemModel>();
  const [postDrawerOpen, setPostDrawerOpen] = useState(false);
  const resultRef = useRef<HTMLDivElement>(null);
  const { isMobile } = useCheckIsMobile();
  const { isLogin, guideToRegisterOrLogin } = useRegisterOrLoginGuide();
  const [openErrorSearchContent, setOpenErrorSearchContent] = useState<any>(null);
  const [innerAccountInfo, setInnerAccountInfo] = useState<InsAccountModel>();
  const { isPremium } = useCommentViewPremium();

  const router = useRouter();
  const searchRequestRef = useRef<{ mediaName: string | null; isRequesting: boolean }>({
    mediaName: null,
    isRequesting: false,
  });
  const { media_name } = router.query;

  const ShowQueryPosts = useMemo(() => {
    if (queryPostsModel) {
      const tempList = queryPostsModel?.items.filter((item) => item.code !== currentSelectedPostCode);
      return { ...queryPostsModel, items: tempList };
    }
  }, [queryPostsModel, currentSelectedPostCode]);

  useEffect(() => {
    if (!media_name || media_name === searchRequestRef.current.mediaName) {
      return;
    }

    if (searchRequestRef.current.isRequesting) {
      return;
    }

    setSearchStr(media_name as string);
    searchRequestRef.current.mediaName = media_name as string;
    onSearch(media_name as string);
  }, [media_name]);

  const showInvalidNameAlert = () => {
    setOpenErrorSearchContent({
      title: t('Content Not Found'),
      desc: t(
        'We couldn’t locate any Instagram profile or post for that link or username.Please check the spelling or try a different one.'
      ),
      btnTitle: t('TRYAGAIN'),
    });
  };
  const showPrivateAccountAlert = () => {
    setOpenErrorSearchContent({
      title: t('Private Content Detected'),
      desc: t(
        'The profile or post you entered is set to private, please search with a public profile or post link instead.'
      ),
      btnTitle: t('TRYAGAIN'),
    });
  };

  const onValueChanged = (e?: string) => {
    setSearchStr(e || '');
  };
  const onSearch = (e?: string, pageToken?: string, isNext?: boolean) => {
    ga_logEvent(EventName.post_comment_s_n, {
      search_str: e,
    });
    e = e?.replace?.('https://www.instagram.com/reels/', 'https://www.instagram.com/p/');
    setLoading(true);
    setAnalysisCommentData(null);
    setAnalysisPostData(null);
    fetchInsPostCommentPostData(e, pageToken, { isPremium, bizFuncName: 'comment_viewer' }).then((res) => {
      setLoading(false);
      if (res.code === 0) {
        setCurrentSelectedPostCode(res.data?.items?.[0]?.code);
        setCurrentSelectedPost(res.data?.items?.[0]);
        if (!isNext) {
          const postClickPoint = document.getElementById('post-click-point');
          postClickPoint?.scrollIntoView({ behavior: 'smooth' });
        }

        if (isEmpty(pageToken)) {
          setCurrentSelectedPostCode(res.data?.items?.[0]?.code);
          setCurrentSelectedPost(res.data?.items?.[0]);
          setQueryPostsModel(res?.data);
        } else {
          const tempList = [...queryPostsModel?.items, ...res?.data?.items];
          setQueryPostsModel({ ...res?.data, items: tempList });
        }
      } else if (res.code === 25005 || res.code == 25010 || res.code == 10001) {
        showInvalidNameAlert();
      } else if (res.code === 22004) {
        showPrivateAccountAlert();
      } else {
        message.error(res.message);
      }
    });
  };

  const [analysisCommentData, setAnalysisCommentData] = useState<PostCommentAnalysisModel>(null);
  const commentsRef = useRef<InstagramPostsCommentsItemModel[]>([]);
  const [commentLoading, setCommentLoading] = useState(false);
  const handleCommentAnalysis = (comments: InstagramPostsCommentsItemModel[]) => {
    setCommentLoading(true);
    fetchInsPostCommentAnalysisData(comments, { isPremium, bizFuncName: 'comment_viewer' }).then((res) => {
      if (res.code === 0 && res.data) {
        setAnalysisCommentData(res.data);
      }
      setCommentLoading(false);
    });
  };

  const [analysisPostData, setAnalysisPostData] = useState<PostAnalysisModel>(null);
  const [postAnalysisLoading, setPostAnalysisLoading] = useState(false);
  const handlePostAnalysis = () => {
    setPostAnalysisLoading(true);
    fetchInsPostCommentPostAnalysisData(searchStr, { isPremium, bizFuncName: 'comment_viewer' }).then((res) => {
      if (res.code === 0) {
        setAnalysisPostData(res.data);
      }
      setPostAnalysisLoading(false);
    });
  };

  // 搜索

  const [userSubData, setUserSubData] = useState<InstagramUserSubModel>();

  const refreshUserData = () => {
    fetchInsPostCommentUserSubData().then((res) => {
      if (res.code === 0) {
        setUserSubData(res.data);
      }
    });
  };

  useEffect(() => {
    if (isLogin) {
      // 刷新用户订阅数据
      refreshUserData();
      // 刷新分析图表
      handlePostAnalysis();
      // 刷新分析数据
      handleCommentAnalysis(commentsRef.current);
    }
  }, [isLogin]);

  const [openErrorAlterModal, setOpenErrorAlterModal] = useState<any>(null);

  const alterUpgrade = () => {
    ga_logEvent(EventName.comment_upgrade_paywall_shown);
    setOpenErrorAlterModal({
      title: t('Upgrade to Continue'),
      desc: t('You’ve reached your free limit. Upgrade to keep using all features.'),
      btnTitle: t('Get Premium'),
      type: true,
      cancelBtnTitle: t('Not Now'),
    });
  };

  const notEnoughScoreNotEilte = () => {
    setOpenErrorAlterModal({
      title: t('Out of Credits'),
      desc: t('You’ve run out of credits. Upgrade your plan to get more.'),
      btnTitle: t('Upgrade Plan'),
      type: true,
      cancelBtnTitle: t('Cancel'),
    });
  };
  const isGoPlan = useRef(false);
  const notEnoughScoreEilte = () => {
    isGoPlan.current = true;
    setOpenErrorAlterModal({
      title: t('Credits Maxed Out'),
      desc: t('You’ve used all your credits. New credits will refresh on your next billing cycle.'),
      type: false,
      btnTitle: t('Got It'),
    });
  };

  const isFreeOrBasic = useMemo(() => {
    return userSubData?.package_type == '' || userSubData?.package_type === 'basic' || !userSubData?.package_type;
  }, [userSubData]);

  const analysisData = useMemo(() => {
    return analysisCommentData && !commentLoading
      ? analysisCommentData
      : {
          total_comments: 15,
          positive_count: 11,
          negative_count: 0,
          neutral_count: 4,
          positive_percentage: 73.33,
          negative_percentage: 0,
          neutral_percentage: 26.67,
          sentiment_summary:
            'Most comments showed clear positive emotions, including emoticons of love and support. A few comments are emotionally neutral and lack clear emotional orientation.',
        };
  }, [analysisCommentData, commentLoading]);

  const [isChancePost, setIsChancePost] = useState(false);

  return (
    <div>
      <div className="max-w-[1200px] mx-auto lg:px-0 px-4">
        <TopSearchContent
          inputPlaceholder={t('Enter profile link or username')}
          topInfo={contentData?.contentInfo?.hero}
          loading={loading}
          searchVal={searchStr}
          showSearchBtnWithFullWidth
          onValueChanged={onValueChanged}
          onSearchClick={(val) => {
            onSearch(val || searchStr);
            if (!isFreeOrBasic) {
              handlePostAnalysis();
            }
          }}
          isLogin={isLogin}
        />
        {isLogin && <UserSub userSubData={userSubData} t={t} />}
        <div className="max-w-[984px] mx-auto">
          {queryPostsModel && (
            <InstagramAccountInfo mediaName={queryPostsModel?.post_user?.username} onInfoChange={setInnerAccountInfo} />
          )}
          {queryPostsModel?.items?.length > 0 && (
            <div
              className="text-xl mt-8 mb-8 font-medium max-md:my-5 max-md:text-base lg:scroll-mt-[200px]"
              id="post-click-point"
            >
              {currentSelectedPostCode && currentSelectedPostCode !== queryPostsModel?.items[0]?.code ? (
                <span>{t('Selected Post')}</span>
              ) : (
                <>
                  <span>{t('Latest posts from')}</span>
                  <span>{` @${queryPostsModel?.post_user?.username}`}</span>
                </>
              )}
            </div>
          )}
          {currentSelectedPost && (
            <>
              <PostInfoPannel
                functionChild={contentData?.function_child}
                alterUpgrade={alterUpgrade}
                notEnoughScoreNotEilte={notEnoughScoreNotEilte}
                notEnoughScoreEilte={notEnoughScoreEilte}
                item={currentSelectedPost}
                isLogin={isLogin}
                drawerOpen={postDrawerOpen}
                onDrawerClose={() => setPostDrawerOpen(false)}
                userSubData={userSubData}
                setIsChancePost={setIsChancePost}
                refreshUserData={refreshUserData}
                innerAccountInfo={innerAccountInfo}
                firstGetComments={(comments: InstagramPostsCommentsItemModel[]) => {
                  if (!isFreeOrBasic && comments.length > 0) {
                    handleCommentAnalysis(comments);
                  }
                }}
                getCommnets={(comments: InstagramPostsCommentsItemModel[]) => {
                  commentsRef.current = comments;
                }}
              />
              <SentimentBreakdown
                guideToRegisterOrLogin={guideToRegisterOrLogin}
                isLogin={isLogin}
                commentLoading={commentLoading}
                handleAnalysis={() => {
                  handleCommentAnalysis(commentsRef.current);
                }}
                isLock={isFreeOrBasic}
                t={t}
                analysisData={analysisData}
                alterUpgrade={alterUpgrade}
              />
              <AccountPerformance
                t={t}
                guideToRegisterOrLogin={guideToRegisterOrLogin}
                isLogin={isLogin}
                isLock={isFreeOrBasic}
                commentLoading={postAnalysisLoading}
                alterUpgrade={alterUpgrade}
                analysisPostData={analysisPostData && !postAnalysisLoading ? analysisPostData : defaultAnalysisPostData}
              />
            </>
          )}

          {/* 帖子列表标题 */}
          {queryPostsModel?.items?.length > 0 && (
            <div className="text-xl mt-12 mb-8 font-medium max-md:mt-9 max-md:mb-5 max-md:text-base">
              <span>{t('View all posts from')}</span>
              <span>{` @${queryPostsModel?.post_user?.username}`}</span>
            </div>
          )}
          {/* 帖子列表 */}
          <div ref={resultRef}>
            <PostListContent
              loading={loading}
              data={ShowQueryPosts}
              onNextClick={() => {
                guideToRegisterOrLogin(() => {
                  if (isEmpty(searchStr) || isEmpty(queryPostsModel?.page_token)) {
                    return;
                  }
                  onSearch(searchStr, queryPostsModel?.page_token, true);
                });
              }}
              onItemClick={(item) => {
                if (!isChancePost) {
                  setCurrentSelectedPost(item);
                  guideToRegisterOrLogin(() => {
                    item.code && setCurrentSelectedPostCode(item?.code);
                    isMobile && setPostDrawerOpen(true);
                    if (!isMobile) {
                      const point = document.querySelector('#post-click-point');
                      point?.scrollIntoView({ behavior: 'smooth' });
                    }
                  });
                }
              }}
            />
          </div>
          <Disclaimer />
        </div>
        <DownloadInstagramContent data={contentData?.contentInfo['section-1']} />
        <ChooseContent data={contentData?.contentInfo['section-2']} />
        <GeneralExampDownloadContent data={contentData?.contentInfo['section-3']} />
        <WhyDownloadStoriesContent data={contentData?.contentInfo['section-4']} />
        <CommentsPlan locale={data.locale} guideToRegisterOrLogin={guideToRegisterOrLogin} isLogin={isLogin} />
        <InstagramActivityTrackerContent
          contentData={contentData}
          isTracker={true}
          webBg={'https://res-front.pumpsoul.com/ins-prod/image/activity_tracker_bg_web_0110_1.webp'}
          phoneBg={'https://res-front.pumpsoul.com/ins-prod/image/activity_tracker_bg_phone_0109.webp'}
        />
        <CustomersTalkUsContent contentInfo={contentData?.contentInfo?.['section-user-reviews']} />
        {contentData?.faqList && (
          <FAQContent faqInfo={contentData?.contentInfo?.['section-faq']} faqList={contentData?.faqList} />
        )}
        <BestTipsContent
          title={contentData?.contentInfo?.['section-top-blog']?.title}
          blogList={contentData?.topBlogList}
        />
        <BestTipsContent title={contentData?.contentInfo?.['section-blog']?.title} blogList={contentData?.blogList} />
      </div>
      <DownloadStoriesBottomContent
        bottomInfo={contentData?.contentInfo['section-buttom']}
        placeholder={t('Enter an Instagram username or profile link')}
        buttonTitle={t('Search Now')}
        loading={false}
        searchVal={searchStr}
        inputVisible={true}
        onValueChanged={(e) => {
          setSearchStr(e);
        }}
        onSearchClick={() => {
          onSearch(searchStr);
        }}
      />
      {/* 弹窗 */}
      <CommonSimpleModal
        open={openErrorSearchContent !== null}
        title={openErrorSearchContent?.title}
        desc={openErrorSearchContent?.desc}
        btnTitle={openErrorSearchContent?.btnTitle}
        closeAction={() => {
          setSearchStr('');
          setOpenErrorSearchContent(null);
        }}
      />
      <AlterModal
        visible={openErrorAlterModal !== null}
        title={openErrorAlterModal?.title}
        type={openErrorAlterModal?.type}
        btnTitle={openErrorAlterModal?.btnTitle}
        cancelBtnTitle={openErrorAlterModal?.cancelBtnTitle}
        desc={openErrorAlterModal?.desc}
        onCancel={() => {
          setOpenErrorAlterModal(null);
        }}
        onUpgrade={() => {
          ga_logEvent(EventName.comment_upgrade_now_click);
          setOpenErrorAlterModal(null);
          if (!isGoPlan.current) {
            document.getElementById('pricing-title')?.scrollIntoView({ behavior: 'smooth' });
          }
          isGoPlan.current = false;
        }}
      />
    </div>
  );
}
